import { useNavigate } from "react-router-dom"

import ErrorLayout from "modules/layout/error"
import Logo from "components/logo"

import { ReactComponent as HomeIcon } from "assets/icons/home.svg"
import PageNotFoundImg from "assets/page-not-found.png"

import styles from "./styles.module.scss"
import { Button, Space } from "antd"
import { useTranslation } from "react-i18next"

const NotFound: React.FC = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  return (
    <ErrorLayout>
      <div>
        <ErrorLayout.Icon>
          <Logo />
        </ErrorLayout.Icon>
        <ErrorLayout.Error>{t("errors.404.title")}</ErrorLayout.Error>
        <ErrorLayout.Title>{t("errors.404.sub_title")}</ErrorLayout.Title>
        <img
          src={PageNotFoundImg}
          alt="page not found"
          style={{ display: "block", marginBottom: "var(--size-3)" }}
        />
        <ErrorLayout.Subtitle>{t("errors.404.message")}</ErrorLayout.Subtitle>

        <div className={styles.popular}>
          <Button onClick={() => navigate("/")} size="large" type="primary">
            <Space>
              <HomeIcon />
              <span>{t("errors.404.home")}</span>
            </Space>
          </Button>
        </div>
      </div>
    </ErrorLayout>
  )
}

export default NotFound
